export default {
  region: process.env.VUE_APP_AWS_REGION,
  Node: process.env.NODE_ENV,
  StripePublishableKey: process.env.VUE_APP_STRIPE_API_PUBLISHABLE_KEY,
  WebsocketEndpoint: process.env.VUE_APP_WEBSOCKET_ENDPOINT || 'localhost',
  apiProtocol: process.env.VUE_APP_API_PROTOCOL || 'https',
  apiUrl: process.env.VUE_APP_API_BASE_URL,
  apiBasePath: process.env.VUE_APP_API_BASE_PATH,
};
